import utbetalingsoversiktActions from "./utbetalingsoversiktActions";

export default utbetalingsoversiktActions;
